import React, { useState } from "react";
import { Linkedin, Phone, Mail } from "lucide-react";
import SectionJumpsNav from "./SectionJumpsNav";

const SIDEBAR_LINKS = {
  linkedin: "https://www.linkedin.com/in/claudia-von-tein-1ba43868/",
  phone: "tel:06983835170",
  email: "mailto:info@repexo.de",
};

const iconClass = "h-5 w-5 text-black";

export default function StickyContactSidebar({
  sections = [],
  scrollRootRef = null,
}) {
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const hasJumps = sections && sections.length > 0;
  const isExpanded = sidebarHovered || isMobileOpen;
  const asideW = hasJumps ? (isExpanded ? "w-[200px]" : "w-[52px]") : "w-[52px]";
  const visibilityClass = isMobileOpen ? "flex" : "hidden md:flex";

  return (
    <>
      {/* Sidebar: always visible on desktop; toggled by + / × button on mobile */}
      <aside
        onMouseEnter={() => setSidebarHovered(true)}
        onMouseLeave={() => setSidebarHovered(false)}
        className={`fixed right-0 top-1/2 z-40 -translate-y-1/2 ${visibilityClass} flex-col rounded-l-xl bg-white/95 shadow-[0_0_24px_rgba(0,0,0,0.08)] border border-gray-200/80 border-r-0 backdrop-blur-sm transition-[width] duration-200 ease-out ${asideW}`}
        aria-label="Seitenleiste Kontakt und Navigation"
      >
        {hasJumps && (
          <SectionJumpsNav
            sections={sections}
            scrollRootRef={scrollRootRef}
            expanded={isExpanded}
          />
        )}
        <div className="flex flex-col gap-2 p-2 shrink-0 border-t border-gray-200/60">
          <a
            href={SIDEBAR_LINKS.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-contact-link flex items-center justify-center w-9 h-9 rounded-lg text-black transition-all duration-200 hover:scale-110 hover:shadow-md"
            aria-label="LinkedIn"
          >
            <Linkedin className={iconClass} strokeWidth={2} />
          </a>
          <a
            href={SIDEBAR_LINKS.phone}
            className="sidebar-contact-link flex items-center justify-center w-9 h-9 rounded-lg text-black transition-all duration-200 hover:scale-110 hover:shadow-md"
            aria-label="Anrufen"
          >
            <Phone className={iconClass} strokeWidth={2} />
          </a>
          <a
            href={SIDEBAR_LINKS.email}
            className="sidebar-contact-link flex items-center justify-center w-9 h-9 rounded-lg text-black transition-all duration-200 hover:scale-110 hover:shadow-md"
            aria-label="E-Mail"
          >
            <Mail className={iconClass} strokeWidth={2} />
          </a>
        </div>
      </aside>

      {/* Mobile toggle button: small + / × under navbar on the right */}
      <button
        type="button"
        onClick={() => setIsMobileOpen((open) => !open)}
        className="fixed right-4 top-24 z-40 flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white/95 text-gray-900 shadow-md md:hidden"
        aria-label={isMobileOpen ? "Seitennavigation schließen" : "Seitennavigation öffnen"}
      >
        <span className="text-2xl leading-none">
          {isMobileOpen ? "×" : "+"}
        </span>
      </button>
    </>
  );
}
